module.exports = __webpack_public_path__ + "fonts/Inter-Regular.2505c0d.woff2";